





































type PropOptionsType = Array<SelectOptionData> | Array<SelectOption>
  | Promise<Array<SelectOptionData>>
  | Promise<Array<SelectOption>>
  | (() => Promise<Array<SelectOptionData>>)
  | (() => Promise<Array<SelectOption>>)
  | null

import Vue from 'vue'
import { Component, Emit, Prop, Watch } from 'vue-property-decorator'

import { SelectOptionData } from '../components/Pi/types'
import { SelectOption } from '../logic/types'
import EmptyData from './EmptyData/EmptyData.vue'

@Component({
  components: {
    EmptyData
  }
})
export default class CreateIfEmpty extends Vue {
  @Prop() options!: PropOptionsType

  @Prop() emptyMessage!:string

  @Prop({ type: Boolean }) disabled!:boolean

  @Emit('onCreateClick')
  onCreateClick() {
    return
  }

  loading = false

  optionsSelect: Array<SelectOptionData> | Array<SelectOption> | null = []

  @Watch('options', { deep: true, immediate: true })
  async onOptionsChange(options: PropOptionsType) {
    if (typeof options === 'function') {
      this.loading = true
      const callableOptions = options()

      if (callableOptions instanceof Promise) {
        this.optionsSelect = await callableOptions
      } else {
        this.optionsSelect = callableOptions
      }
      this.loading = false
    }

    if (Array.isArray(options)) {
      this.optionsSelect = options
    }

    if (options === null) {
      this.optionsSelect = null
    }
  }

  get message():string {
    if (this.emptyMessage) {
      return this.emptyMessage
    }

    return this.$t('list_empty').toString()
  }
}
